/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Autorisation d'un support de souscription sur le tunnel.
 * @export
 * @interface CreateSupportTunnelCommand
 */
export interface CreateSupportTunnelCommand {
    /**
     * 
     * @type {boolean}
     * @memberof CreateSupportTunnelCommand
     */
    isTunnelGLI?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateSupportTunnelCommand
     */
    tunnelId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSupportTunnelCommand
     */
    typeSupportId: string;
    /**
     * 
     * @type {number}
     * @memberof CreateSupportTunnelCommand
     */
    ordreAffichage?: number;
}

/**
 * Check if a given object implements the CreateSupportTunnelCommand interface.
 */
export function instanceOfCreateSupportTunnelCommand(value: object): value is CreateSupportTunnelCommand {
    if (!('tunnelId' in value) || value['tunnelId'] === undefined) return false;
    if (!('typeSupportId' in value) || value['typeSupportId'] === undefined) return false;
    return true;
}

export function CreateSupportTunnelCommandFromJSON(json: any): CreateSupportTunnelCommand {
    return CreateSupportTunnelCommandFromJSONTyped(json, false);
}

export function CreateSupportTunnelCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSupportTunnelCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'isTunnelGLI': json['isTunnelGLI'] == null ? undefined : json['isTunnelGLI'],
        'tunnelId': json['tunnelId'],
        'typeSupportId': json['typeSupportId'],
        'ordreAffichage': json['ordreAffichage'] == null ? undefined : json['ordreAffichage'],
    };
}

export function CreateSupportTunnelCommandToJSON(json: any): CreateSupportTunnelCommand {
    return CreateSupportTunnelCommandToJSONTyped(json, false);
}

export function CreateSupportTunnelCommandToJSONTyped(value?: CreateSupportTunnelCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isTunnelGLI': value['isTunnelGLI'],
        'tunnelId': value['tunnelId'],
        'typeSupportId': value['typeSupportId'],
        'ordreAffichage': value['ordreAffichage'],
    };
}

